// extracted by mini-css-extract-plugin
module.exports = {"Container":"BackgroundBlock_Container__2E3vf","Block":"BackgroundBlock_Block__2IZgr"};